import axios, { type AxiosResponse } from "axios";
import { CookieService } from "../../../services";
import { type ISpecialty, type Option, type IPersonaEntry } from "./types";

const getContentCategory = () => {
    const jwt = CookieService.readCookie("piap_jwt_token");
    const URL = `${process.env.REACT_APP_API_BASE_URL}/persona/therapeutic-area`;
    return axios
        .post(
            URL,
            {},
            {
                headers: { Authorization: `Bearer ${jwt}` },
            }
        )
        .then((result) => {
            return generateOption(result.data);
        })
        .catch((err) => {
            return err;
        });
};

const generateOption = (values: ISpecialty[]) => {
    const jsonData: Option[] = [];

    values.map((item) => {
        const _option: Option = { text: "", value: "" };
        _option.text = item.Name;
        _option.value = item.Id;
        return jsonData.push(_option);
    });
    return jsonData;
};

const getVeevaSpecilaty = (country: string) => {
    const jwt = CookieService.readCookie("piap_jwt_token");
    const URL = `${process.env.REACT_APP_API_BASE_URL}/abbvie-pro/speciality-list-piap`;
    return axios
        .post(
            URL,
            {
                country,
                language: "EN",
            },
            {
                headers: { Authorization: `Bearer ${jwt}` },
            }
        )
        .then((result: AxiosResponse) => {
            return generateOption(result.data.data);
        })
        .catch((err) => {
            throw new Error(err);
        });
};

const findDuplicate = (arr: IPersonaEntry[]) => {
    let temp = {};
    for (let i = 0; i < arr.length; i++) {
        // @ts-expect-error: Unreachable code error
        if (temp[[arr[i].personaKey, arr[i].audienceType]]) return i;
        temp = {
            ...temp,
            // @ts-expect-error: Unreachable code error
            [[arr[i].personaKey, arr[i].audienceType]]: true,
        };
    }
    return false;
};

const AUDIENCE_TYPE = [
    {
        value: "content-category",
        text: "Content Category",
    },
    {
        value: "specialty",
        text: "Specialty",
    },
];

export { getContentCategory, getVeevaSpecilaty, findDuplicate, AUDIENCE_TYPE };
